export default () => ({
  modalActive: false,
  signinType: 'auth', // auth | reg | restore
})
